import { render, staticRenderFns } from "./commonTree.vue?vue&type=template&id=4b8cff13&scoped=true"
import script from "./commonTree.vue?vue&type=script&lang=js"
export * from "./commonTree.vue?vue&type=script&lang=js"
import style0 from "./commonTree.vue?vue&type=style&index=0&id=4b8cff13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8cff13",
  null
  
)

export default component.exports